export default {
    /**
     * cookie操作
     * 增 删 获取
     */
    cookie: {
        set: function (key, value, expire) {
            var date = new Date();
            date.setSeconds(date.getSeconds()+expire);
            document.cookie = key + '=' + value + ";expire=" + date.toGMTString();
        },
        //  set: function (key, value, expire) {
        //    document.cookie = key + '=' + value;
        //  },
        get: function (key) {
            // cookie 里获取 access_token
            let strCookie = document.cookie;
            // 将多cookie切割为多个名/值对
            let arrCookie = strCookie.split(';');
            let accessToken;
            // 遍历cookie数组，处理每个cookie对
            for (let i = 0; i < arrCookie.length; i++) {
                let arr = arrCookie[i].split('=');
                // 找到名称为access_token的cookie，并返回它的值
                if (key === arr[0]) {
                    accessToken = arr[1];
                    break;
                }
            }
            return accessToken;
        },
        delete: function (key) {
            let myDate = new Date();
            myDate.setTime(-1000); // 设置时间
            document.cookie = key + "=''; expires=" + myDate.toGMTString();
        }
    }
};



// WEBPACK FOOTER //
// ./src/common/js/cookieOperation.js